import { useAppSelector } from "@/shared/lib/redux"
import { StatisticsBlock } from "@/shared/ui/statistics-block"
import MainBalanceSvg from '@/shared/assets/images/Money.svg' 
import MarketBalanceSvg from '@/shared/assets/images/Coins.svg' 
import UsersSvg from '@/shared/assets/images/UsersFour.svg' 
import { selectTotalUsersCount } from "../../model/selectors"
import { fromNanoToUnit } from "@/entities/bonus"
import { selectCommunityInfo, selectMainWallet, selectMasterWallet } from "@/entities/community"
import { toLocaleString } from "@/shared/lib/to-locale-string"
import { useNavigate } from "react-router-dom"

export const CommunityStats = () => {
    const navigate = useNavigate()
    const walletBalance = useAppSelector(selectMainWallet)
    const masterWalletBalance = useAppSelector(selectMasterWallet)
    const communityInfo = useAppSelector(selectCommunityInfo)
    const totalUsers = useAppSelector(selectTotalUsersCount)

    return (
        <div className='flex flex-col gap-4'>
            <StatisticsBlock
                className="screen:!py-5"
                icon={MainBalanceSvg}
                label='Корпоративный баланс кошелька'
                value={`${toLocaleString(fromNanoToUnit(walletBalance[communityInfo.main_bonus] ?? 0))} ₽`}
            />
            <StatisticsBlock
                className="screen:!py-5"
                icon={MarketBalanceSvg}
                label='Маркетинговый баланс кошелька'
                value={`${toLocaleString(fromNanoToUnit(masterWalletBalance ?? 0))} ₽`}
            />
            <StatisticsBlock
                className="screen:!py-5 hover:cursor-pointer"
                icon={UsersSvg}
                label='Всего пользователей'
                onClick={() => navigate('/users/list')}
                value={toLocaleString(totalUsers ?? 0)}
            />
        </div>
    )
}